import React, { useState } from 'react';
import clsx from 'clsx';

import CommonLoader from '../../../../../../../components/common-loader/CommonLoader';
import ImageModal from '../../../../../../../ai-studio/media-gallery/image-modal/ImageModal';
import ErrorLoading from '../../../../../components/error-loading/ErrorLoading';
import BackgroundImage from '../../../../../../components/content-media/background-image/BackgroundImage';
import { STORY_GENERATED_CONTENT_SUBTYPE } from '../../../../../../../constants';
import useStoryGeneratedImage from '../../hooks/useStoryGeneratedImage';

import scss from './ContentPreview.module.scss';

function ContentPreview({ subtype, link, isPending = false }) {
  const isVideo = subtype === STORY_GENERATED_CONTENT_SUBTYPE.MP4;
  const { mediaUrl, error, isLoading, imageProps, videoProps } = useStoryGeneratedImage({
    src: isPending ? null : link,
    subtype,
  });

  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const handleOpenPreview = () => {
    if (!mediaUrl || error || isPending) return;

    setIsPreviewOpen(true);
  };

  const handleClosePreview = () => {
    setIsPreviewOpen(false);
  };

  const showLoader = isPending || isLoading;
  const showPlaceholderHeight = (showLoader || error) && !mediaUrl;

  return (
    <div className={scss.wrapper}>
      <div className={clsx(scss.mediaWrapper, showPlaceholderHeight && scss.mediaWrapperPlaceholder)}>
        {error ? <ErrorLoading /> : null}

        {!error && !isPending && mediaUrl && !isVideo ? (
          <img
            src={mediaUrl}
            alt=''
            className={scss.image}
            onClick={handleOpenPreview}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                handleOpenPreview();
              }
            }}
            role='presentation'
            {...imageProps}
          />
        ) : null}

        {!error && !isPending && mediaUrl && !isVideo ? <BackgroundImage src={mediaUrl} alt='' /> : null}

        {!error && !isPending && mediaUrl && isVideo ? (
          <video src={mediaUrl} className={scss.video} controls playsInline preload='metadata' {...videoProps}>
            <track kind='captions' />
          </video>
        ) : null}

        <CommonLoader isLoading={showLoader} width={24} strokeWidth='3' />
      </div>

      <ImageModal isOpen={isPreviewOpen} onClose={handleClosePreview} src={mediaUrl} alt='' />
    </div>
  );
}

export default ContentPreview;
